import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-convenience-list',
	templateUrl: './convenience-list.component.html',
	styleUrls: ['./convenience-list.component.css'],
})
export class ConvenienceListComponent extends ListComponent {
	protected apiUrl = 'product/convenience';
	protected apiType = 'bag';
	codebook;
	title: string;
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'convenience', name: 'Nazwa angielska' },
		{ id: 'multimedia', name: 'Multimedia' },
	];

	filters = {
		limit: 9999,
	};

	protected convertData(result) {
		return result.results.map((obj) => {
			obj.multimedia = obj.multimedia?.name;
			return obj;
		});
	}
	protected loadBefore(): void {
		this.bag.get('/codebook/6/', (result, error) => {
			this.codebook = result;

			this.title = `Słowniki -> ${this.codebook.name}`;
			this.loadData();
		});
	}
}
